<template>
  <div class="event">
    <loading v-if="loading"></loading>
    <div class="m-container" v-else>
      <!-- current Events -->
      <div class="current-events">
        <div class="head-title">
          <p>Happening Now</p>
        </div>

        <div class="row current-event-row">
          <div v-if="popular.current == ''">There is no events yet</div>
          <div class="col-xs-12 col-sm-4 col-lg-4 events-card" v-for="item in popular.current" :key="item.id" @click="redirectTo(item.id)">
            <div class="events-body">
              <div class="events-img">
                <img :src="item.photo">
              </div>
              <div class="events-text">
                <p>{{item.title}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Calender -->
      <calender :allEvents="popular"></calender>
      <!-- End Calender -->

      <!-- Up coming Events -->
      <div class="Up-coming-events">
        <div class="head-title">
          <p>Upcoming Events</p>
        </div>

        <div class="row current-event-row">
          <div v-if="popular.newevent == ''">There is no events yet</div>
          <div class="col-xs-12 col-sm-4 col-lg-4 events-card" v-for="item in popular.newevent" @click="redirectTo(item.id)">
            <div class="events-body">
              <div class="events-img">
                <img :src="item.photo">
              </div>
              <div class="events-text">
                <p>{{item.title}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Past Events -->
      <div class="Past-events">
        <div class="head-title">
          <p>Past Events</p>
        </div>

        <div class="row current-event-row">
          <div v-if="popular.oldevent == ''">There is no events yet</div>
          <div class="col-xs-12 col-sm-4 col-lg-4 events-card" v-for="item in popular.oldevent" @click="redirectTo(item.id)">
            <div class="events-body">
              <div class="events-img">
                <img :src="item.photo">
              </div>
              <div class="events-text">
                <p>{{item.title}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Calender from "@/components/web/event/Calender";
import Loading from "@/components/Loading/loading";
export default {
  data:() => ({
    loading: true,
    events: [],
    popular:  [],
  }),
  components: {Loading, Calender},
  methods: {
    redirectTo(event_id) {
        this.$router.push({name:'Event-Details',params:{ id: event_id }});
    },
  },
  mounted() {
    this.$API.web.event.show_popular()
    .then(response => {
      this.loading = false;
      this.popular = response.data;

    })
    .catch( error => {
        console.log(error);
    });
  }
}
</script>

<style scoped>

.event{
  padding-top: 30px;
}

.event .current-event-row{
  margin-bottom: 50px;
}


.events-card{
  padding-left: 18px;
  margin-bottom: 15px;
  cursor: pointer;
}

.event .events-img img {
  border-radius: 9px;
  height:  291px;
  width: 100%;
  object-fit: cover;
}

.event .events-text p{
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
</style>